import React from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { showHideScreenSize } from "../actions/ShowHide";
import { dropShowHide } from "../actions/dropShowHide";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Slide from "@material-ui/core/Slide";
import MenuIcon from "@material-ui/icons/Menu";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import { darkTheme } from "../actions/darkTheme";
import HomeIcon from "@material-ui/icons/Home";
import { Button, Typography } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const SimpleMediaQuery = () => useMediaQuery("(min-width:600px)");

const useStyles = (dark) =>
  makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      paddingTop: "50px",
    },
    AppBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    bar: {
      backgroundColor: dark ? "#001C41" : "#EEEEEE",
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    darkThemeButton: {
      position: "absolute",
      right: "15px",
    },
    arrowBackIcon: {
      position: "absolute",
      right: "65px",
    },
    title: {
      flexGrow: 1,
    },
    logoGob: {
      position: "absolute",
      left:
        window.innerWidth >= 768
          ? "1vh"
          : window.innerWidth >= 414
          ? "-12vh"
          : window.innerWidth >= 375
          ? "-15vh"
          : window.innerWidth >= 360
          ? "-18vh"
          : window.innerWidth <= 320
          ? "-23vh"
          : "-20vh",
      top:
        window.innerWidth >= 768
          ? "-67px"
          : window.innerWidth <= 320
          ? "-82px"
          : "-76px",
      transform:
        window.innerWidth >= 768
          ? "scale(0.35)"
          : window.innerWidth > 375
          ? "scale(0.28)"
          : window.innerWidth <= 320
          ? "scale(0.2)"
          : "scale(0.25)",
    },
    logoConaset: {
      position: "absolute",
      left: "14.8%",
      top: "22px",
      transform: window.innerWidth >= 768 ? "scale(1.4)" : "scale(1)",
    },
  }))();

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const HeaderContainer = (props) => {
  const { showHideScreenSize, desktop, dark, darkTheme } = props;
  const classes = useStyles(dark);
  let history = useHistory();
  return (
    <div className={classes.root} id="back-to-top-anchor">
      <HideOnScroll {...props}>
        <AppBar className={classes.AppBar}>
          <Toolbar className={classes.bar}>
            <Button
              edge="start"
              className={"px-2 " + classes.menuButton}
              aria-label="menu"
              onClick={() => showHideScreenSize(!desktop)}
              style={{
                color: "#EEEEEE",
                backgroundColor: "#0f69b4",
                zIndex: 99999,
              }}
            >
              <MenuIcon />
              <Typography
                variant="button"
                style={{
                  paddingTop: "1px",
                  color: "#EEEEEE",
                  zIndex: 11111,
                }}
              >
                {" "}
                Menú
              </Typography>
            </Button>
            <a href="https://mejoresconductores.conaset.cl/">
              <img
                src={
                  dark
                    ? "assets/img/conaset-gob-dark.png"
                    : "assets/img/conaset-gob-light.png"
                }
                alt="Logo Gobierno"
                className={classes.logoGob}
              />
            </a>
            <IconButton
              edge="end"
              className={classes.arrowBackIcon}
              aria-label="regresar"
              onClick={() => history.push("/")}
            >
              <HomeIcon />
            </IconButton>
            {/* <IconButton
              edge="end"
              className={classes.darkThemeButton}
              aria-label="modo-oscuro"
              onClick={() => darkTheme()}
            >
              {dark ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton> */}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
    </div>
  );
};

HeaderContainer.propTypes = {};

const mapStateToProps = (state) => ({
  desktop: state.menu.desktop,
  mobile: state.menu.mobile,
  dropDown: state.dropDown.show,
  dark: state.dark,
});

export default connect(mapStateToProps, {
  showHideScreenSize,
  dropShowHide,
  darkTheme,
})(HeaderContainer);
